import type { ActionType } from "../types/action";

export interface PasswordCheckResult {
  readonly accepted: boolean;
  readonly complete: boolean;
  readonly remaining: number;
}

export function checkPasswordAttempt(
  expected: readonly ActionType[],
  attempt: readonly ActionType[],
): PasswordCheckResult {
  if (expected.length === 0) {
    return {
      accepted: attempt.length === 0,
      complete: true,
      remaining: 0,
    };
  }

  const complete = attempt.length >= expected.length;
  const suffix = complete ? attempt.slice(attempt.length - expected.length) : [];
  const accepted = complete && expected.every((e, i) => e === suffix[i]);

  return {
    accepted,
    complete,
    remaining: Math.max(0, expected.length - attempt.length),
  };
}
